"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
var _mixins = _interopRequireDefault(require("./mixins"));
var _default = exports.default = {
  name: 'WlTree',
  mixins: _mixins.default,
  props: {},
  data: function data() {
    return {
      treeFilterValue: '',
      treeData: [],
      tree: {
        'node-key': 'id',
        'highlight-current': true,
        'expand-on-click-node': false
      },
      treeProps: {
        children: 'children'
      },
      pagination: {
        show: true,
        total: 0,
        pageSize: 10,
        currentPage: 1,
        small: true,
        background: false,
        // layout: 'total, ->, prev, ->, pager,next',
        'hide-on-single-page': true,
        layout: 'total, ->, prev, jumper, next',
        'pager-count': 5,
        'page-sizes': [5, 10, 20, 30, 40, 50, 100]
      },
      loading: false,
      tooltip: {
        show: false
      }
    };
  },
  /* 数据监听 */
  watch: {
    treeFilterValue: {
      handler: function handler(nv, ov) {
        var _this$$refs$elTree;
        if (!nv && ov) (_this$$refs$elTree = this.$refs['el-tree']) === null || _this$$refs$elTree === void 0 || _this$$refs$elTree.filter('');
      },
      deep: true
    }
  },
  computed: {
    treeOptions: function treeOptions() {
      if (this.$attrs.treeKey) this.tree['node-key'] = this.$attrs.treeKey;
      return Object.assign(this.tree, this.$attrs);
    },
    getProps: function getProps() {
      var _ref, _this$$attrs$treeLabe;
      return Object.assign(this.treeProps, this.tree.props, {
        label: (_ref = (_this$$attrs$treeLabe = this.$attrs.treeLabel) !== null && _this$$attrs$treeLabe !== void 0 ? _this$$attrs$treeLabe : this.$attrs.label) !== null && _ref !== void 0 ? _ref : 'label'
      });
    }
  },
  methods: {
    /**  获取分页数据
     * @description: 获取 分页数据
     * @return { Object } 分页数据
     */
    getPagination: function getPagination() {
      return this.pagination;
    },
    /** 设置分页器
     * @description: 设置分页器
     * @param { Object } pagination - 分页器属性
     * @param { String | Number } pagination.currentPage - 当前页页码
     * @param { String | Number } pagination.pageSize - 每页显示条目
     * @param { String | Number } pagination.total - 条目总数
     * @return { void }
     */
    setPagination: function setPagination(pagination) {
      var p = pagination !== null && pagination !== void 0 ? pagination : this.paginationOptions;
      // 合并分页器的参数设置
      switch (this.$$dataTypeOf(p, true)) {
        case '[object Object]':
          Object.assign(this.pagination, p);
          break;
        case '[object Boolean]':
          this.pagination.show = p;
          break;
      }
    },
    /** 重置数据
     * @return { void }
     */
    reset: function reset() {
      this.$refs['el-tree'].setCurrentKey(null);
      this.$refs['el-tree'].setCheckedNodes([]);
      // this.$$listenersEmit('node-click', {}, {}, {})
      // this.$$listenersEmit('tree-node-click', {}, {}, {})
    }
  },
  created: function created() {
    this.getDatas();
    // console.log(this.$attrs, this)
  },
  updated: function updated() {
    // console.log(this.$refs['el-tree'])
    // this.getDatas()
    // this.renderData()
  }
};